module.exports = __webpack_public_path__ + "static/media/logo_color_canvas.e1707aab.png";